const SectionDivider = () => {
  return (
    <div className="w-full flex justify-center py-1 sm:py-1.5">
      <div 
        className="w-1/2 max-w-md mx-4 sm:mx-6 h-px bg-gradient-to-r from-transparent via-accent/80 to-transparent animate-pulse"
        style={{
          boxShadow: '0 0 32px hsl(var(--accent) / 0.8), 0 0 64px hsl(var(--accent) / 0.4)'
        }}
      />
    </div>
  );
};

export default SectionDivider;
